import { signOut } from "@aws-amplify/auth";
import { getCurrentUser } from "aws-amplify/auth";
import { useEffect, useState } from "react";
import { FaExclamationTriangle, FaSearchLocation } from "react-icons/fa";
import { GiCircuitry } from "react-icons/gi";
import { LuScanSearch } from "react-icons/lu";
import { MdLogout } from "react-icons/md";
import { RxMagicWand } from "react-icons/rx";
import { VscBug } from "react-icons/vsc";
import { TbBook2, TbFolderSearch } from "react-icons/tb";
import { useNavigate } from "react-router-dom";
import { RegulifyService } from "../api/RegulifyService";

const Sidebar = ({ selectedTab, setSelectedTab }) => {
  const [userEmail, setUserEmail] = useState("");
  const navigate = useNavigate();

  const tabs = [
    // { value: "ReguBot", label: "ReguBot", icon: <RxMagicWand /> },
    { value: "PredicateFinder", label: "PredicateFinder", icon: <FaSearchLocation /> },
    { value: "AdverseEvents", label: "AdverseEvents", icon: <VscBug /> },
    { value: "DocReviewer", label: "ComplianceChecker", icon: <LuScanSearch /> },
    { value: "RiskManager", label: "RiskManager", icon: <FaExclamationTriangle /> },
    { value: "ChangeManagement", label: "ChangeClarity", icon: <GiCircuitry /> },
    {
      value: "ClinicalEval",
      label: "ClinicalLitrReview",
      icon: <TbFolderSearch />,
      children: [
        {
          value: "DeepLiteratureAnalysis",
          label: "DeepLitrAnalysis",
          icon: <TbBook2 />,
        },
      ],
    },
  ];

  useEffect(() => {
    let isMounted = true;

    const fetchUser = async () => {
      try {
        const user = await getCurrentUser();
        if (isMounted && user) {
          setUserEmail(user?.signInDetails?.loginId || user?.username);
        }
      } catch {
        // EXPECTED during logout — do not log as error
      }
    };

    fetchUser();

    return () => {
      isMounted = false;
    };
  }, []);

  const handleLogout = async () => {
    const session_id = sessionStorage.getItem("session_id");
    const email_id = sessionStorage.getItem("email_id");
    try {
      if (session_id && email_id) {
        await RegulifyService.cleanupSessionData(session_id, email_id);
      }
    }
    catch (e) {
      console.warn("Cleanup failed", e);
    }
    finally {
      await signOut();
      navigate("/login"); // Redirect to login page after logout
    }
  };

  return (
    <ul className="menu menu-lg bg-base-100 text-base-content relative min-h-full w-60 pt-2">
      {/* Logo */}
      <li className="mt-3">
        <a
          href="/"
          className="flex items-center gap-4 px-3 py-2 rounded-lg hover:bg-base-200 transition"
        >
          <img
            src="/RegulifyAI_192p.png"
            alt="RegulifyAI Logo"
            className="w-12 mask mask-squircle drop-shadow"
          />
          <span className="text-xl font-bold tracking-wide">
            Regulify<span className="text-primary">.AI</span>
          </span>
        </a>
      </li>

      <div className="divider" />

      {/* Menu Items */}
      {tabs.map((tab) => {
        const isActive =
          selectedTab === tab.value ||
          tab.children?.some((child) => child.value === selectedTab);

        if (tab.children) {
          return (
            <li key={tab.value}>
              <a
                href={`/tap/${tab.value}`}
                onClick={(e) => {
                  e.preventDefault();
                  setSelectedTab(tab.value);
                }}

                className={`
                    flex items-center gap-3
                    text-lg md:text-xl tracking-wide
                    transition-all duration-200
                    ${isActive
                    ? `
                          active
                          bg-base-300
                          font-bold
                          text-primary/80
                          border-l-4
                          border-primary
                        `
                    : `
                          font-medium
                          text-base-content
                          opacity-90
                          hover:opacity-100
                          hover:bg-base-200
                        `
                  }
                  `}
              >
                <span
                  className={`text-lg ${isActive ? "text-primary/80" : "text-base-content/80"
                    }`}
                >
                  {tab.icon}
                </span>

                <span>{tab.label}</span>
              </a>

              <ul>
                {tab.children.map((child) => {
                  const childActive = selectedTab === child.value;

                  return (
                    <li key={child.value}>
                      <a
                        href={`/tap/${child.value}`}
                        onClick={(e) => {
                          e.preventDefault();
                          setSelectedTab(child.value);
                        }}
                        className={`
                              flex items-center gap-3
                              text-lg md:text-xl tracking-wide
                              transition-all duration-200
                              ${childActive
                            ? `
                                    active
                                    bg-base-300
                                    font-bold
                                    text-primary/80
                                    border-l-4
                                    border-primary
                                  `
                            : `
                                    font-medium
                                    text-base-content
                                    opacity-90
                                    hover:opacity-100
                                    hover:bg-base-200
                                  `
                          }
                            `}
                      >
                        <span
                          className={`
                              text-lg
                              ${childActive ? "text-primary/80" : "text-base-content/80"}
                            `}
                        >
                          {child.icon}
                        </span>
                        <span
                          className={`
                              text-lg
                              ${childActive ? "text-primary/80" : "text-base-content/80"}
                            `}
                        >
                          {child.label}
                        </span>
                      </a>
                    </li>
                  );
                })}
              </ul>
            </li>
          );
        }

        return (
          <li key={tab.value}>
            <a
              href={`/tap/${tab.value}`}
              onClick={(e) => {
                e.preventDefault();
                setSelectedTab(tab.value);
              }}
              className={`
              flex items-center gap-3
              text-lg md:text-xl tracking-wide
              transition-all duration-200
              ${isActive
                  ? `
                    active
                    bg-base-300
                    font-bold
                    text-primary/80
                    border-l-4
                    border-primary
                  `
                  : `
                    font-medium
                    text-base-content
                    opacity-90
                    hover:opacity-100
                    hover:bg-base-200
                  `
                }
            `}
            >
              <span
                className={`text-lg ${isActive ? "text-primary/80" : "text-base-content/80"
                  }`}
              >
                {tab.icon}
              </span>
              <span>{tab.label}</span>
            </a>
          </li>
        );
      })}

      {/* User Info */}
      <div className="absolute bottom-24 left-0 w-full px-4">
        <div className="divider" />
        <p className="text-sm text-gray-500">Logged in as:</p>
        <p className="truncate text-sm font-medium text-gray-700">
          {userEmail}
        </p>
      </div>

      {/* Logout */}
      <li className="absolute bottom-4 left-4">
        <button
          onClick={handleLogout}
          className="flex items-center gap-2 rounded bg-gray-300 px-4 py-2 text-black shadow transition hover:bg-gray-400"
        >
          <MdLogout />
          Logout
        </button>
      </li>
    </ul>
  );
};

export default Sidebar;
